import axios from 'axios';

function ServiceAxios(base_url, timeout) {
  const auth = localStorage.getItem('auth');
  const modoAnonimo = localStorage.getItem('modoAnonimo');
  let headers = {};
  if(auth){
    const auth_json = JSON.parse(auth);
    headers.token = auth_json.result.token;
  }
  else{
    headers.token = '';
  }
  if (modoAnonimo) {
    const modoAnonimoTratado = JSON.parse(modoAnonimo);
    headers.modoAnonimo = modoAnonimoTratado;
  }
  else {
    headers.modoAnonimo = false;
  }
  const api = axios.create(
    {
      baseURL: base_url,
      timeout: timeout,
      headers: headers
    }
  );
  api.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    console.log(error.request);
    return Promise.resolve(error.request);
  });

  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    console.log(error.response);
    return Promise.resolve(error.response)
  });
  return api;
}



export {ServiceAxios};
